import { render, staticRenderFns } from "./SourceConfigForm.vue?vue&type=template&id=60466e6a"
import script from "./SourceConfigForm.vue?vue&type=script&lang=js"
export * from "./SourceConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports